import '../../styles/styles.css';
import React from 'react';
import StoryblokService from '../../lib/storyblok-service';

import Layout from '../../components/Layout';
import NewsHeader from '../../components/NewsHeader';
import StoryblokComponents from '../../components/storyblok/StoryblokComponents.js';
import NewsList from '../../components/NewsList';
import getNewsList from '../../lib/getNewsList';
import getFeaturedProjects from '../../lib/getFeaturedProjects';
import useEditableContent from '../../lib/hooks/useEditableContent';

const StoryblokNewsItem = ({
  story,
  date,
  newsList,
  featuredProjectsList,
  preview,
}) => {
  const content = useEditableContent(story?.content, preview);

  return (
    <>
      {content && (
        <Layout
          metaData={{
            data: {
              title: story.content.meta_title || story.name,
              description: story.content.meta_description,
              image: story.content.meta_image,
            },
          }}
          featuredProjectsList={featuredProjectsList}
        >
          <article className="components page">
            <NewsHeader
              component={{
                title: content?.meta_title || story.name,
                date: date,
              }}
            />

            {content?.body.map((block) => (
              <StoryblokComponents block={block} key={block._uid} />
            ))}

            <NewsList
              newsList={newsList.json}
              total={newsList.total}
              cssModifier={'news-list--news_post'}
            />
          </article>
        </Layout>
      )}
    </>
  );
};

// This function gets called at build time on server-side.
export async function getStaticProps(ctx) {
  let { params, preview } = ctx;

  preview = preview || process.env.NODE_ENV !== 'production';

  const res = await StoryblokService.get(
    `cdn/stories/news/${params.storyblok}`,
    {
      version: preview ? 'draft' : 'published',
    }
  );

  const story = res.data.story;

  const rawDate =
    res.data.story.content.override_date ||
    res.data.story.first_published_at ||
    res.data.story.created_at;

  const date = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    timeZone: 'Europe/Amsterdam',
  }).format(new Date(rawDate));

  const newsList = await getNewsList();

  const featuredProjectsList = await getFeaturedProjects();

  return {
    props: { date, story, newsList, featuredProjectsList, preview },
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export default StoryblokNewsItem;
